import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { TextField } from '@material-ui/core';
import { Field } from 'formik';
import { CardNumberElement, CardCvcElement, CardExpiryElement } from '@stripe/react-stripe-js';
import { useStyles } from '../PurchaseBlock/hooks/useStyles';

import { LabelText } from 'components/UI/Text/TextStyles';
import { colors } from 'utils/styles/styles';
import 'styles/creditCard.scss';
import useContribution from '../../hooks/useContribution.js';
import { TemplateType } from 'helpers/constants/templateType.js';
import { determineDarkThemedColorToUse, getThemedColors } from 'services/contributions.service';
import useApplicationStatus from 'hooks/useApplicationStatus';
import useAccount from 'hooks/useAccount';

export const StyledInput = styled.input`
  padding: 6px 11px 10px 11px;
  border: 0;
  border-bottom: 1px solid #b3b3b3;
  outline: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    border-color: none;
  }

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }

  ${({ error }) =>
    error &&
    css`
      border-color: #ff4d4f;
    `}
`;

const StyledCustomToSGrid = styled(Grid)`
  color: ${colors.darkOceanBlue};
  font-weight: 600;
  text-decoration: underline;
`;

const StyledLink = styled.a`
  color: ${colors.darkOceanBlue};
  font-weight: 600;
`;

const StyledError = styled.div`
  color: ${({ template, PrimaryColor }) =>
    template === TemplateType.TemplateOne
      ? PrimaryColor
        ? PrimaryColor
        : '#6999CA'
      : PrimaryColor
      ? PrimaryColor
      : '#D08ACD'};
  font-size: 14px;
  margin-top: 2px;
  padding-left: 10px;
`;

const CARD_OPTIONS = {
  style: {
    base: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 400,
      fontFamily: `Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
      "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
      sans-serif`,
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': { color: '#2b2b2b' },
      '::placeholder': { color: 'darkgray' },
    },
    invalid: {
      color: '#ff4d4f',
    },
  },
};

const CARD_NUMBER_OPTIONS = {
  ...CARD_OPTIONS,
  placeholder: 'Card Number',
};

function CustomCreditCard({ handleChange, activeTemplate, colorToUse, values, touched, errors, setShowTerms }) {
  const { serviceProviderName, customToS } = useContribution();
  const classNames = useStyles();
  const PrimaryColor = colorToUse?.PrimaryColorCode;
  const notLegacyTemplaate = activeTemplate != TemplateType.TemplateThree;
  const contribution = useContribution();
  const { newThemedTextColor, newThemedBackgroundColor } = getThemedColors(contribution);
  const isDarkThemeEnabled = determineDarkThemedColorToUse(contribution);
  const { user } = useAccount();

  const { applicationRequiredButNotApproved } = useApplicationStatus({ contribution, user });
  return (
    <>
      {!applicationRequiredButNotApproved && (
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <LabelText style={{ color: newThemedTextColor }}>Payment Method</LabelText>
          </div>
          <br />
          <Grid container spacing={1}>
            <Grid item sm={6} xs={12}>
              {/* <Field
            component={StyledInput}
            name="Name"
            placeholder="Name on Card"
            type="text"
            onChange={handleChange('Name')}
            error={touched.Name && errors.Name}
          /> */}
              <TextField
                fullWidth
                className={classNames.nameInputFieldForCard}
                name="Name"
                placeholder="Name on Card"
                variant="outlined"
                onChange={handleChange}
                // onBlur={handleBlur}
                value={values.Name}
                type="text"
                InputProps={{
                  classes: { notchedOutline: classNames.noBorder },
                  style: { color: newThemedTextColor, backgroundColor: newThemedBackgroundColor, borderRadius: '10px' },
                }}
              />
              {touched.Name && errors.Name && (
                <StyledError PrimaryColor={PrimaryColor} template={activeTemplate}>
                  {errors.Name}
                </StyledError>
              )}
            </Grid>
            <Grid item sm={6} xs={12}>
              <CardNumberElement
                style={{ color: 'white' }}
                className={isDarkThemeEnabled ? classNames.inputFieldForCardDark : classNames.inputFieldForCard}
                options={CARD_NUMBER_OPTIONS}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <CardExpiryElement
                className={isDarkThemeEnabled ? classNames.inputFieldForCardDark : classNames.inputFieldForCard}
                options={CARD_OPTIONS}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <CardCvcElement
                className={isDarkThemeEnabled ? classNames.inputFieldForCardDark : classNames.inputFieldForCard}
                options={CARD_OPTIONS}
              />
            </Grid>

            {/* <Grid item>
          <span className="mr-1">By clicking Reserve, I agree to the</span>
          <StyledLink
            href="/"
            onClick={e => {
              e.preventDefault();
              setShowTerms(true);
            }}
          >
            Terms and Conditions.
          </StyledLink>
        </Grid> */}

            {/* {customToS && (
          <Grid item>
            <span className="mr-1">By clicking Reserve, I also agree to {serviceProviderName}'s</span>
            <StyledLink href={customToS}>Terms and Conditions.</StyledLink>
          </Grid>
        )} */}
          </Grid>
        </>
      )}
    </>
  );
}

CustomCreditCard.propTypes = {
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  setShowTerms: PropTypes.func.isRequired,
};

export default CustomCreditCard;
